import { AnimatePresence, motion } from 'framer-motion'
import React, { Fragment, useEffect, useRef, useState } from 'react'
import { BsChevronDown } from 'react-icons/bs'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import { loginStore, useRecoilState, useRecoilValue, useSetRecoilState } from '@/store'
import { AreaGroupType } from '@/store/login'
const { stepState, stepTxtState, areaListState } = loginStore

interface Props {
  onChange: (code: string) => void
  areaCode: string
}

export default ({ onChange, areaCode }: Props) => {
  const [state, setState] = useState(false)
  const [val, setVal] = useState('')
  const [localArea, setLocalArea] = useState<AreaGroupType[]>([])
  const areaList = useRecoilValue(areaListState)

  useEffect(() => {
    setLocalArea(areaList)
  }, [areaList])

  useEffect(() => {
    document.addEventListener('click', globalClick, false)
    return () => {
      document.removeEventListener('click', globalClick, false)
    }
  })

  //键盘事件函数
  const globalClick = () => {
    setState(false)
  }

  const change = (e: { target: { value: any } }) => {
    const { value } = e.target
    setVal(value)
    const reg = /^[A-Za-z]/
    let filterList = []
    if (value.length === 1 && reg.test(value)) {
      filterList = areaList.filter((item) => {
        return item.index === value.toUpperCase()
      })
    } else if (value.length >= 1) {
      const countryItem: any[] = []
      areaList.forEach((item) => {
        const { list, index } = item
        const arr = list.filter(({ area, areaCode }) => {
          return area.indexOf(value) >= 0 || areaCode.indexOf(value) >= 0
        })
        if (arr.length > 0) {
          countryItem.push({ index, list: arr })
        }
      })

      filterList = countryItem
    } else if (value === '') {
      filterList = areaList
    }
    setLocalArea(filterList)
  }

  return (
    <Container initial={{ opacity: 0, scale: 0.98 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.98 }} className="w-[120px] relative">
      <div
        className="flex cursor-pointer justify-center items-center"
        onClick={(e) => {
          e.stopPropagation()
          setState(true)
        }}
      >
        <span className=" block min-w-[64px] text-center text-[20px] text-[#666]">{areaCode}</span>
        <BsChevronDown className="mx-[10px]" />
      </div>

      <AnimatePresence>
        {state ? (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            className="card w-[350px] h-[370px] absolute top-[40px] left-0 bg-white z-20 flex flex-col justify-center items-center"
            onClick={(e) => {
              e.stopPropagation()
            }}
          >
            <div className="search w-full h-[60px] flex justify-center items-center py-[13px]  px-[16px]">
              <input value={val} onChange={change} className="h-[36px] w-full rounded-md border-[#aaa]" type="text" placeholder="搜索" />
            </div>
            <div className="area-list flex-1 w-full overflow-auto">
              <ul className="list-none p-0 m-0 mb-[13px]">
                {localArea.map((group, i) => (
                  <li className="area-group" key={i}>
                    <div className="text-[14px] text-[#888] bg-[#F8F8F8] h-[38px] flex items-center pl-[16px]">{group.index}</div>
                    <ul className="area-item list-none m-0 px-[16px]">
                      {group.list.map((item, index) => (
                        <li
                          className="w-full h-[38px] flex items-center cursor-pointer text-[#666] text-[14px] hover:text-[#ff783a]"
                          key={index}
                          onClick={() => {
                            onChange(item.areaCode)
                            setState(false)
                          }}
                        >
                          {item.areaCode}：{item.area}
                        </li>
                      ))}
                    </ul>
                  </li>
                ))}
              </ul>
            </div>
          </motion.div>
        ) : null}
      </AnimatePresence>
    </Container>
  )
}

const Container = styled(motion.div)`
  .card {
    box-shadow: rgb(0 0 0 / 15%) 0px 5px 10px 0px;
    border-radius: 6px;
    border: 1px solid #d0d0d0;
  }
  .search {
    box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;
  }
`
